import React from 'react';
import { connect } from 'react-redux';
import * as fieldsActions from '../../store/fields/actions';
import { getField } from '../../store/reducers';

import styles from './FormInput.scss';
import TextareaInput from './TextareaInput';
import TextInput from './TextInput';
import PasswordInput from './PasswordInput';
import SearchInput from './SearchInput';
import EmailListInput from 'Components/EmailListInput';
import CheckboxInput from './CheckboxInput';
import StaticTextInput from './StaticTextInput';
import StripeCardInput from './StripeCardInput';

/*
  Unlike other components, we are nesting _all_ form inputs in this directory.
  This means every input will have the class 'FormInput' and not have its own
  style files.
*/

class FormInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorClass: props.showError && !props.isValid ? ' has-error' : '',
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      errorClass: nextProps.showError && !nextProps.isValid ? ' has-error' : '',
    });
  }

  render() {
    const newProps = {
      ...this.props,
      ...this.state,
      updateFieldValidity: (value, validity) =>
        this.props.updateFieldValidity(this.props, value, validity),
    };
    if (this.props.type === 'static') return <StaticTextInput {...newProps} />;
    switch (this.props.fieldName) {
      case 'given_name':
      case 'family_name':
      case 'username':
      case 'className':
      case 'billing_email':
      case 'billing_phone':
        return <TextInput {...newProps} />;
      case 'password':
      case 'currentPassword':
      case 'newPassword':
      case 'newPasswordAgain':
        return <PasswordInput {...newProps} />;
      case 'newsletter':
      case 'acceptTerms':
      case 'tipsTricks':
        return <CheckboxInput {...newProps} />;
      case 'inviteList':
        return <EmailListInput {...newProps} />;
      case 'searchFilter':
        return <SearchInput {...newProps} />;
      case 'accessCode':
        return <TextInput {...newProps} autoCapitalize="characters" />;
      case 'credit_card':
        return <StripeCardInput {...newProps} />;
      default:
        return <TextInput {...newProps} />;
    }
  }
}

const mapStateToProps = (state, { mustMatch, formId }) => ({
  fieldToMatch: getField(state, `${formId}__${mustMatch}`),
});

export default connect(mapStateToProps, fieldsActions)(FormInput);
